import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReportBuilderService } from '@app/main/report/services/report-builder.service';
import { IReportTemplateSection } from '@shared/interfaces';

@Component({
    selector: 'app-report-guidance',
    templateUrl: './report-guidance.component.html',
    styleUrls: ['./report-guidance.component.scss'],
    standalone: false
})
export class ReportGuidanceComponent {
    constructor(
        public dialogRef: MatDialogRef<ReportGuidanceComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            text: string;
            textDe: string;
            section: IReportTemplateSection;
        },
        public builder: ReportBuilderService
    ) {}

    protected get isDe() {
        return this.builder.reportLanguage === 'de';
    }

    protected get sectionTitle(): string {
        return this.isDe && this.data.section.titleDe ? this.data.section.titleDe : this.data.section.title;
    }

    protected get guidance(): string {
        return this.isDe && this.data.textDe ? this.data.textDe : this.data.text;
    }

    protected close(): void {
        this.dialogRef.close(this.data);
    }
}
